export default "__VITE_ASSET__Bgynm3aq__"